/* eslint-disable import/no-anonymous-default-export */
import { DataService } from "./DataService";

const MINTBOX_CLIENT_ID = "Li2L9VO1eawEbsgLrHdpZjhmUdW6N8Cm";

export default {

  getClientGrowth: async (id = -1) => {
    return DataService.get("/Admin/getClientGrowth?ifaId=" + id);
  },

  addBankAccount: async (data) =>
    DataService.post("/SignUp/addBankAccount", data),
  updateBankAccount: async (data) =>
    DataService.post("/SignUp/updateBankAccount", data),

  getAccessToken: async () => {
    return DataService.get("/Auth/getToken?clientId=" + MINTBOX_CLIENT_ID);
  },

  getClient: async (id) => {
    return DataService.get("/Dashboard/getClient?clientid=" + id);
  },

  emailExist: async (id, data, optionalHeader) => {
    return DataService.get(
      "/SignUp/EmailExists?email=" + id,
      data,
      optionalHeader
    );
  },
  clientExists: async (value, type) => {
    return DataService.get("/SignUp/ClientExists?type=" + type + "&value=" + value);
  },
  ifaExists: async (value, type = "email") => {
    return DataService.get("/IFA/IFAExists?type=" + type + "&value=" + value);
  },
  generateOTP: async (value, type) => {
    return DataService.post("/SignUp/generateOTP?type=" + type + "&value=" + value);
  },
  login: async (clientId) => {
    return DataService.post("/SignUp/login?clientId=" + clientId);
  },
  IFAlogin: async (ifaId) => {
    return DataService.post("/IFA/login?ifaid=" + ifaId);
  },
  loginwithPass: async (data) => {
    return DataService.post("/SignUp/login", data);
  },
  validatePin: async (data) => {
    return DataService.post("/SignUp/validatePIN", data);
  },
  sendOTP: async (phone, email) => {
    return DataService.post("/SignUp/generateOTP?mobileNumber=" + phone + "&email=" + email);
  },

  forgotPass: async (data) => {
    return DataService.post("/SignUp/generatePasswordLink", data);
  },

  getETFQuantities: async (data) => {
    return DataService.post(
      "/StrategyAutomation/getFundQuantity", data
    );
  },

  validateToken: async (data) => {
    return DataService.post("/SignUp/validatePasswordLink", data);
  },

  savePass: async (data) => {
    return DataService.post("/SignUp/savePassword", data);
  },

  createUser: async (data) => {
    return DataService.post("/SignUp/openAccount", data);
  },

  createIFA: async (data) => {
    return DataService.post("/IFA/openAccount", data);
  },

  getIFAClients: async (id = -1) => {
    return DataService.get("/IFA/getIFAClients?ifaId=" + id);
  },

  addRisk: async (data) => {
    return DataService.post("/Dashboard/addRisk", data);
  },
  addEducationGoal: async (data) => {
    return DataService.post("/Dashboard/addEducationGoal", data);
  },
  addRetirmentGoal: async (data) => {
    return DataService.post("/Dashboard/addRetirementGoal", data);
  },

  deactivateAccount: async (id) => {
    return DataService.post(`/Signup/deleteAccount?clientId=` + id);
  },

  updateBenchmarkTRI: async (data) => {
    return DataService.post(`/Feeds/insertBenchmarkRecord`, data);
  },


  updateVRTable: async (data) => {
    return DataService.post(`/ValueResearch/updateTables`, data);
  },
  getInstrumentDesc: async (instrumentType) => {
    return DataService.get(`/Content/getInstrumentDesc?isFresh=true&instrumentType=` + instrumentType)
  },
  updateInstrumentDesc: async (data) => {
    return DataService.post(`/Content/updateInstrumentDesc`, data)
  },
  saveBlogCategory: async (data) => {
    return DataService.post(`/Content/saveBlogCategory`, data)
  },
  getBlogCategories: async () => {
    return DataService.get(`/Content/getBlogCategories`);
  },
  saveBlogSubCategory: async (data) => {
    return DataService.post(`/Content/saveBlogSubCategory`, data);
  },
  getBlogSubCategories: async () => {
    return DataService.get(`/Content/getBlogSubCategories`);
  },
  saveBlog: async (data) => {
    return DataService.post(`/Content/saveBlog`, data)
  },
  getBlogs: async () => {
    return DataService.get(`/Content/getBlogs`)
  },
  readBlogFile: async (fileName) => {
    return DataService.get(`/AWS/readFile?bucketName=mintbox-assets&folderName=blogs&fileName=` + fileName)
  },
  readKBArticleFile: async (fileName) => {
    return DataService.get(`/AWS/readFile?bucketName=mintbox-assets&folderName=knowledge-base&fileName=` + fileName)
  },
  deleteBlog: async (blogId) => {
    return DataService.post(`/Content/deleteBlog?blogId=${blogId}`)
  },
  deleteBlogCategory: async (categoryId) => {
    return DataService.post(`/Content/deleteBlogCategory?categoryId=${categoryId}`)
  },
  deleteBlogSubCategory: async (subCategoryId) => {
    return DataService.post(`/Content/deleteBlogSubCategory?subCategoryId=${subCategoryId}`)
  },
  insertSharpelyBenchData: async (data) => {
    return DataService.post(`/Dashboard/updateIndexPrices`, data)
  },
  updateAccess: async (data) => {
    return DataService.post(`/Dashboard/updateAccess`, data)
  },
  uploadImg: async (fileName, data) => {
    return DataService.postImg(`/AWS/updateToS3?filename=${fileName}&bucketName=mintbox-assets&folderName=app-images/blogimages`, data)
  },
  insUpBanksNPA: async (data) => {
    return DataService.post(`/Dashboard/InsUpBanksNPA`, data)
  },
  getPPSubscriptions: async (id) => {
    return DataService.get(`/Payment/getPPSubscriptions?clientId=${id}`)
  },
  getPPTrans: async (id, subId) => {
    return DataService.get(`/Payment/getPPTransactions?clientId=${id}&subscriptionId=${subId}`)
  },
  getPPAuthReqStatus: async (id) => {
    return DataService.get(`/Payment/getPPAuthReqStatus?authRequestId=${id}`)
  },
  getPPAuthRequests: async (id) => {
    return DataService.get(`/Payment/getPPAuthRequests?subscriptionId=${id}`)
  },
  initiatePPDebit: async (data) => {
    return DataService.post(`/Payment/recurringInit`, data)
  },
  recurringExec: async (data) => {
    return DataService.post(`/Payment/recurringExec`, data)
  },
  getRazorPlans: async () => {
    return DataService.get(`/Payment/razor/getPlans`);
  },
  getRazorSubscriptionsByCustId: async ({ id }) => {
    return DataService.get(`/Payment/razor/getSubscriptionsByCustId?id=${id}`)
  },
  updateToS3: async ({ fileName, folderName, data }) => {
    return DataService.postImg(`/AWS/updateToS3?filename=${fileName}&bucketName=mintbox-assets&folderName=${folderName}`, data)
  },
  readFile: async ({ fileName, folderName }) => {
    return DataService.get(`/AWS/readFile?bucketName=mintbox-assets&folderName=${folderName}&fileName=` + fileName)
  },
  updateSharpelyAccess: async (data) => {
    return DataService.post(`/Dashboard/updateSharpelyAccess`, data);
  },
  getPPDashboardData: async () => {
    return DataService.get(`/Payment/getPPDashboardData`);
  }
};
